export default __webpack_public_path__ + "static/media/ImagenRevisaCorreo.9c373ab4.png";